// Texty mobilního ovládání výpisu (mobileFilter.js) — sticky lišta, off-canvas
// filtr, bottom-sheet řazení.
export default {
  filter: 'Filtrovat',
  filterTitle: 'Filtrace',
  filterClose: 'Zavřít filtr',
  sortOpen: 'Seřadit',
  /** tlačítko nese zvolené řazení: „Řadit: Doporučujeme" */
  sortPrefix: 'Řadit: ',
  sortTitle: 'Seřadit podle',
  clear: 'Vymazat',
  clearAll: 'Vymazat vše',
  /** „Zobrazit N produktů" */
  show: (n, word) => 'Zobrazit ' + n + ' ' + word,
  showAll: 'Zobrazit produkty',
};
